import React from "react";
import { Row, Col, Typography } from "antd";
import colors from "constants/colors";
import useViewport from "components/UseViewport/UseViewport";
import ArticleCards from "./ArticleCards/ArticleCards";
import { StyledFirstWave, StyledSecondWave, WaveContainer } from "./style";

const { Title, Text } = Typography;

const NewsSection: React.FC = () => {
  const { width } = useViewport();

  return (
    <div style={{ position: "relative", marginTop: "7em" }}>
      <WaveContainer>
        <StyledFirstWave
          preserveAspectRatio="none"
          viewBox="0 0 1440 124"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M830.725 123L828.65 123.5H0V79.9648C7.92529 80.4688 16.8804 81.6201 26.9644 83.5C130.711 102.843 396.829 66.9463 623.604 36.3564C766.141 17.1299 893.134 0 954.5 0C1113.5 0 1168.92 41.5 1168.92 41.5L930.316 99H1440V123H830.725Z"
            fill="#D98618"
          />
        </StyledFirstWave>
        <StyledSecondWave
          style={{ top: 0 }}
          preserveAspectRatio="none"
          viewBox="0 0 1440 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1440 29.6074C1368 12.9648 1241.89 -9.04982 1121.5 4.99999C912 37.5 507.002 88.8389 272.41 88.8389C145.583 88.8389 55.7607 75.873 0 63.9609V119.5H1440V29.6074Z"
            fill="#0A283F"
          />
        </StyledSecondWave>
      </WaveContainer>
      <Row justify="end" style={{ overflow: "hidden", backgroundColor: colors.primary }}>
        <Col
          style={{
            paddingRight: width < 768 ? "2em" : "5em",
            paddingTop: width < 768 ? "2em" : "0",
            textAlign: "right",
          }}
        >
          <Title style={{ color: "white" }} level={2}>
            Nyheter
          </Title>
          <Text style={{ color: "white", fontSize: width < 768 ? "16px" : "18px" }} type="secondary">
            Sjekk ut hva som rører seg i Bindeleddet.
          </Text>
        </Col>
        <Col style={{ backgroundColor: colors.primary, width: "100%", padding: "3em 0", zIndex: 1 }}>
          <ArticleCards />
        </Col>
      </Row>
      <WaveContainer style={{ position: "relative" }}>
        <StyledFirstWave
          style={{ zIndex: 0 }}
          preserveAspectRatio="none"
          viewBox="0 0 1440 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1440 0H0V22H219.312C265.426 65.1201 328.045 92.6172 409 65.5C530.42 24.8291 663.53 42.8535 796.525 60.8623C887.525 73.1846 978.471 85.5 1065.58 79C1280 63 1280 37.5 1280 37.5L1215.68 22H1440V0Z"
            fill="#D98618"
          />
        </StyledFirstWave>

        <StyledSecondWave
          style={{ top: "-5px", zIndex: 0 }}
          preserveAspectRatio="none"
          viewBox="0 0 1440 95"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0.5V66.0508C117.976 116.266 339.333 89.4307 546.587 64.3057C685.662 47.4453 818.387 31.3555 909.263 39.833C944.256 43.0977 979.148 46.7979 1013.53 50.4443C1185.78 68.7109 1345.18 85.6162 1440 39.5059V0.5H0Z"
            fill="#0A283F"
          />
        </StyledSecondWave>
      </WaveContainer>
    </div>
  );
};

export default NewsSection;
